import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Home, Instagram } from "lucide-react";

const ThankYouPage = () => {
  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);

    // Google Analytics conversion event
    if (typeof window.gtag === "function") {
      window.gtag("event", "contact_form_submit", {
        event_category: "engagement",
        event_label: "Contact form submission",
        value: 1,
      });
    }
  }, []);

  return (
    <div
      className="min-h-screen bg-warm-cream flex items-center justify-center px-6 py-16"
      data-testid="thank-you-page"
    >
      <div className="max-w-2xl w-full text-center">
        {/* Animated check icon */}
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-forest-green/10 mb-8 animate-fade-in-up">
          <CheckCircle2
            className="w-14 h-14 text-forest-green"
            strokeWidth={1.5}
            data-testid="success-icon"
          />
        </div>

        {/* Handwritten accent */}
        <span className="font-handwritten text-2xl md:text-3xl text-forest-green block mb-3 opacity-0 animate-fade-in-up animation-delay-100">
          Merci pour votre confiance
        </span>

        {/* Title */}
        <h1
          className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-deep-oak mb-6 opacity-0 animate-fade-in-up animation-delay-200"
          data-testid="thank-you-title"
        >
          Votre message
          <br />
          <span className="text-forest-green">est bien arrivé !</span>
        </h1>

        {/* Description */}
        <p className="text-text-secondary text-base md:text-lg leading-relaxed mb-10 opacity-0 animate-fade-in-up animation-delay-300">
          Nous avons bien reçu votre demande et nous vous recontacterons dans
          les <strong className="text-deep-oak">72 heures</strong>. En
          attendant, n'hésitez pas à découvrir nos dernières réalisations sur
          notre Instagram.
        </p>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-fade-in-up animation-delay-400">
          <Link
            to="/"
            className="btn-primary inline-flex items-center justify-center gap-2"
            data-testid="back-home-btn"
          >
            <Home className="w-5 h-5" />
            Retour à l'accueil
          </Link>
          <a
            href="https://www.instagram.com/ttwood38/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-deep-oak border border-deep-oak/20 hover:bg-deep-oak hover:text-white rounded-full px-8 py-3 transition-all duration-300 font-medium inline-flex items-center justify-center gap-2"
            data-testid="instagram-btn"
          >
            <Instagram className="w-5 h-5" />
            Voir notre Instagram
          </a>
        </div>

        {/* Decorative quote */}
        <div className="mt-16 pt-8 border-t border-deep-oak/10 opacity-0 animate-fade-in-up animation-delay-500">
          <p className="font-handwritten text-2xl text-deep-oak/70 italic">
            "Chaque pièce est unique, comme votre projet."
          </p>
          <p className="text-text-muted text-sm mt-2">— TT Wood, Villard-Bonnot</p>
        </div>

        {/* Subtle back link */}
        <div className="mt-12 opacity-0 animate-fade-in-up animation-delay-500">
          <Link
            to="/#contact"
            className="text-text-muted hover:text-deep-oak transition-colors text-sm inline-flex items-center gap-2"
            data-testid="new-request-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Envoyer une nouvelle demande
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
